export default __webpack_public_path__ + "static/media/img_404.4806f045.png";